/**
 * Converts a CEL string expression into a {@link index!DefaultRuleGroupType DefaultRuleGroupType}
 * or {@link index!DefaultRuleGroupTypeIC DefaultRuleGroupTypeIC}.
 *
 * @module parseCEL
 */

export * from './parseCEL';
